// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2wo-y","content":"Consent_content__ZVBE1","footer":"Consent_footer__1_6v1"};